/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExportedTaskInputEvaluationAnyOf } from './exportedTaskInputEvaluationAnyOf';

export type ExportedTaskInputEvaluation = ExportedTaskInputEvaluationAnyOf | null;
